import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { TemplateTypes } from 'sections/onsite-campaigns/types';

export const useSetTemplate = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (payload: {
      id: string;
      templateId: string;
      templateName: string;
      templateType: TemplateTypes;
      isEmbedded: boolean;
      supportedLanguage: string;
    }) => dispatch({ type: 'SET_TEMPLATE', payload }),
    [dispatch],
  );
};
